export type ChecklistBlockerCode =
  | 'PROOF_REQUIRED'
  | 'PROOF_APPROVER_REQUIRED'
  | 'DEPENDENCY_INCOMPLETE'
  | 'LOCATION_OUT_OF_RANGE'
  | 'RESOURCES_UNVERIFIED'
  | 'ASSIGNEE_REQUIRED'
  | 'ADMIN_ONLY'

export type BlockerCtaSection =
  | 'proof'
  | 'location'
  | 'dependencies'
  | 'assignee'
  | 'resources'
  | 'approver'
  | 'description'
  | 'dates'
  | 'completionCriteria'
  | 'signals'
  | 'fieldPass'
  | 'attachedForms'

export const BLOCKER_MESSAGES: Record<ChecklistBlockerCode, string> = {
  PROOF_REQUIRED: 'Attach the required proof file before completion.',
  PROOF_APPROVER_REQUIRED: 'This item is awaiting approval. Only the assigned approver can mark it complete.',
  DEPENDENCY_INCOMPLETE: 'Complete all dependencies before completing this record.',
  LOCATION_OUT_OF_RANGE: 'You must be within 50 metres of the required location.',
  RESOURCES_UNVERIFIED: 'Resolve required resources before proceeding.',
  ASSIGNEE_REQUIRED: 'Assign a member to this item.',
  ADMIN_ONLY: 'Only workspace admins can mark items as not required.',
}

export const ctaSectionFor = (code: ChecklistBlockerCode): BlockerCtaSection => {
  switch (code) {
    case 'PROOF_REQUIRED':
      return 'proof'
    case 'PROOF_APPROVER_REQUIRED':
      return 'approver'
    case 'DEPENDENCY_INCOMPLETE':
      return 'dependencies'
    case 'LOCATION_OUT_OF_RANGE':
      return 'location'
    case 'RESOURCES_UNVERIFIED':
      return 'resources'
    case 'ASSIGNEE_REQUIRED':
      return 'assignee'
    case 'ADMIN_ONLY':
      return 'approver'
  }
}
